import React from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import cl from './About.module.css';
import AboutInfo from './AboutInfo/AboutInfo';

const About = (props) => {
  const position = props.aboutData.coordinates?.split(', ') || [
    41.911519, 12.503961,
  ];

  return (
    <section className={cl.app_about}>
      <AboutInfo
        shopStory={props.aboutData.story}
        shopStory2={props.aboutData.story2}
        shopStory3={props.aboutData.story3}
      />
      <div className={cl.contacts}>
        <div className={cl.contacts_divs}>
          <div>
            <h1>Contatti</h1>
            <p>
              Email:{' '}
              <a href={'mailto: supporto@' + props.aboutData.domain}>
                supporto@{props.aboutData.domain}
              </a>
            </p>
            <p>{props.aboutData.shopName} Gruppo di negozi</p>
            <p>{props.aboutData.address}</p>
            <p>
              Tel: <a href="tel:+392362588879">+392362588879</a>
            </p>
          </div>
          <MapContainer
            center={position}
            zoom={15}
            scrollWheelZoom={false}
            style={{ height: '450px', width: '700px', margin: '0 auto' }}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={position} />
          </MapContainer>
        </div>
      </div>
    </section>
  );
};

export default About;
